jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false;

	cover_animate_enable = (typeof cover_animate_enable !== 'undefined')? cover_animate_enable : false;
	cover_animate_id = (typeof cover_animate_id !== 'undefined')? cover_animate_id : "cover";
	cover_animate_target = (typeof cover_animate_target !== 'undefined')? cover_animate_target : "#cover-img";
	cover_animate_target_alt = (typeof cover_animate_target_alt !== 'undefined')? cover_animate_target_alt : "#cover-img-alt";



	if(cover_animate_enable && $('#'+cover_animate_id).length && $(cover_animate_target).length && $(cover_animate_target_alt).length) {
		if(logit) console.log('[COVER ANIMATION] Enabled: ' + cover_animate_id + ', '+ cover_animate_target + ', '+ cover_animate_target_alt);





							//el.pulse({ opacity : 0}, { pulses : -1, duration : 500, interval:4000 });

							function toOne() {
								el.css({ opacity : 1});
							  this.pulse({ opacity : .8 }, { pulses : 2, duration : 3000, interval:300 }, toTwo)
							}

							function toTwo() {
							  this.pulse({ opacity : 0.5 }, { pulses : 1, duration : 500, interval:500 }, toThree)
							}

							function toThree() {
							  this.pulse({ opacity : 0.2 }, { pulses : 3, duration : 2000, interval:300 } , toOne)
							}

							var el = $(cover_animate_target);
							el.css({ opacity : 0});
							el.pulse({ opacity : 1 }, { pulses : 2, duration : 3000, interval:200 }, toOne);



	} else {
		if(logit == 2) console.log('[COVER ANIMATION] Disabled');
	}




	// END JQUERY
});
